export const getGoPremiumRoute = (userState: string): string =>
  userState === 'Suspended'
    ? '/manage-account/subscription/update-credit-card'
    : '/select-your-plan';
